export default "__VITE_PUBLIC_ASSET__de6736b4__"